import { render, staticRenderFns } from "./StockAdjustmentForm.vue?vue&type=template&id=2807d868"
import script from "./StockAdjustmentForm.vue?vue&type=script&lang=js"
export * from "./StockAdjustmentForm.vue?vue&type=script&lang=js"
import style0 from "./StockAdjustmentForm.vue?vue&type=style&index=0&id=2807d868&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports